/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ExternalUserAccessToken.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_GET_ACCESS_TOKEN = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `EXTERNALUSERACCESSTOKEN/FETCH_SD_GET_ACCESS_TOKEN`
);

export { FETCH_SD_GET_ACCESS_TOKEN };
